// client/src/app/serverAuthProtected.ts
//
// DEL-864 / DEL-902: routes whose page client component redirects signed-out
// visitors itself, using the SSR-provided serverAuthState prop. LayoutClient's
// PrivateRoute skips its own client-side redirect and loading gate for these,
// because on a fresh context it raced the page's hydration and unmounted
// /income mid-form-fill.
//
// Only list a route here if its page really owns that redirect. DEL-902 also
// listed /assets, /simulations, /settings and /subscription on the theory that
// their data fetches would 401 and sign the user out, but those fetches only
// run once there is a user, so a signed-out visitor sat on a spinner forever.
// serverAuthProtected.test.ts checks each entry's client reads serverAuthState.
export const SERVER_AUTH_PROTECTED = [
  '/dashboard', '/income', '/expenses', '/transactions', '/cashflow',
];

export function pageOwnsAuthRedirect(pathname: string | null): boolean {
  return !!pathname && SERVER_AUTH_PROTECTED.includes(pathname);
}
